import { LocatorStationsWrapper, Station } from "api"
import { useCallback, useState } from "react"
import { useMapCamera } from "./useMapCamera"
import { useMapZoom } from "./useMapZoom"

interface UseMapResponseHandlerOptions {
    stationIdRef: React.MutableRefObject<string | null>
}

export const useMapResponseHandler = ({ stationIdRef }: UseMapResponseHandlerOptions) => {
    const [list, setList] = useState<Station[]>([])
    const { focusOnCity, focusOnQueryLocation, fitStationsBounds } = useMapCamera()
    const { applyZoomConstraints } = useMapZoom()

    const handleResponse = useCallback((
        responseData: LocatorStationsWrapper,
        isStation: boolean,
        map: google.maps.Map | null,
        queryParams?: any
    ) => {
        const response = responseData.Body.body
        setList(isStation ? response.stations.reverse() : response.stations)

        if (!map) return

        // Handle different response scenarios
        if (response.geoCity) {
            // Selected city from search
            focusOnCity(map, response.geoCity.latitude, response.geoCity.longitude)
        } else if (queryParams?.LocationLat || queryParams?.LocationLng) {
            // Selected station from search
            focusOnQueryLocation(map, queryParams.LocationLat, queryParams.LocationLng)
        } else if (response?.stations.length > 0) {
            // Multiple stations - fit bounds
            if (stationIdRef.current) {
                return
            }
            fitStationsBounds(map, response.stations, applyZoomConstraints)
        }
    }, [focusOnCity, focusOnQueryLocation, fitStationsBounds, applyZoomConstraints, stationIdRef])

    return {
        list,
        setList,
        handleResponse
    }
}
